<template>
    <div v-if="center !== null && gpsCardReady">
        <l-map style="height: 350px; border-top-right-radius: 8px; border-top-left-radius: 8px; z-index: 1"
               :zoom="16"
               :options="{
                            dragging: false,
                            zoomControl: false,
                            doubleClickZoom: false
                       }"
               :center="center"
               @ready="setMapCenter">
            <l-tile-layer
              :url="url"
              :attribution="attribution"
              @ready="setMapCenter"
            />
            <l-marker :lat-lng="[diff.new.latitude, diff.new.longitude]" v-if="diff.new">
                <l-icon>
                    <img src="/images/green_marker.svg">
                </l-icon>
            </l-marker>
            <l-marker :lat-lng="[diff.old.latitude, diff.old.longitude]" v-if="diff.old">
                <l-icon>
                    <img src="/images/red_marker.svg">
                </l-icon>
            </l-marker>
        </l-map>
    </div>
</template>

<script>

import { LMap, LTileLayer, LMarker, LIcon } from "vue2-leaflet"
import { latLng } from "leaflet"
import { mapState } from "vuex"

export default {
    name: "GpsFieldDiffs",
    props: ["diff"],
    components: {
        LMap,
        LTileLayer,
        LMarker,
        LIcon,
    },
    data() {
        return {
            url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
            attribution: "&copy; <a href=\"http://osm.org/copyright\">OpenStreetMap</a> contributors",
            center: null,
            gpsCardReady: false
        }
    },
    methods: {
        setMapCenter() {
            if (this.diff.new) {
                this.center = latLng(this.diff.new.latitude, this.diff.new.longitude)
            }
        },
    },
    computed: {
        ...mapState("sitAnswer", [
            "addColors",
            "updateColors",
            "deleteColors",
        ]),
    },
    mounted() {
        this.setMapCenter()
    },
    watch: {
      diff() {
          this.setMapCenter()
      }
    },
    created() {
        setTimeout(() => {
            this.gpsCardReady = true
        }, 300)
    },
}
</script>